var AclPermission = function(opts){
	var self = this;

	self.opts = opts || {};

	self.id = ko.observable(parseInt(self.opts.id || 0));
	self.for_type = ko.observable(self.opts.for_type || '');
	self.for_id = ko.observable(parseInt(self.opts.for_id || 0));
	self.access = ko.observable(parseInt(self.opts.access || 0));

	self.isEmpty = ko.computed(function(){
		return (!this.for_type() || this.for_type() === '' || !this.access() || this.access() === 0);
	}, self);

	self.isUpdated = ko.computed(function(){
		return (this.id() === 0
			|| this.opts.for_type !== this.for_type()
			|| this.opts.for_id !== this.for_id()
			|| this.opts.access !== this.access()
		);
	}, self);

	self.undoChanges = function(){
		self.for_type(self.opts.for_type || '');
		self.for_id(self.opts.for_id || 0);
		self.access(self.opts.access || 0);
	};

	self.resetUpdated = function(){
		self.opts = {for_type: self.for_type(), for_id: self.for_id(), access: self.access()};
		self.for_type.valueHasMutated();
	};

	self.resetUpdated();
};